import API from 'api'
import { remoteLoad } from 'utils/dom'
import { wgs84togcj02 } from 'utils/transformPos'
import env from '@/utils/clientEnv'
export default {
  namespaced: true,
  state: {
    version: env.androidLevel < 6 ? '1.4.15' : '2.0',
    loadingFlag: true,
    // 高德数据
    aMapObj: {
      key: '', // key
      gps: true,
      location: null, // gps定位成功后且转化为高德之后的坐标
      center: null // 地图中心坐标
    },
    placeSearchResult: [], //地图定位搜索列表
    keySearchResult: [], //关键词搜索列表
    placeSearchObj: null // 地图搜索插件对象
  },
  getters: {},
  actions: {
    async getAmapKey({ state, commit }) {
      if (!state.aMapObj.key) {
        let key = '2fe495214f0b8035db56beac12e46e12'
        let data = await API.getLbsKey().catch(() => {})
        if (data) {
          key = data
        }
        commit('setAMapObj', { key })
      }
    },
    // 根据定位逆解析地址
    async getGeocoderAddress({ state, dispatch }, { lnglat, callback }) {
      if (!window.AMap) {
        // 通过接口获取key，如果key不存在，则使用默认的key
        await dispatch('getAmapKey')
        await remoteLoad(`https://webapi.amap.com/maps?v=${state.version}&key=${state.aMapObj.key}`)
      }
      window.AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder()

        geocoder.getAddress(lnglat, function (status, result) {
          callback && callback(status, result)
        })
      })
    },
    // 初始化地图
    async initMapCavas({ state, commit, dispatch }, callback) {
      if (!window.AMap) {
        // 通过接口获取key，如果key不存在，则使用默认的key
        await dispatch('getAmapKey')
        await remoteLoad(`https://webapi.amap.com/maps?v=${state.version}&key=${state.aMapObj.key}`)
      }

      var map = new window.AMap.Map(document.getElementById('J_map'), {
        viewMode: '2D',
        zoom: 17, //初始化地图层级
        touchZoomCenter: 1, //手机端双指缩放的以地图中心为中心，否则默认以双指中间点为中心
        center: state.aMapObj.center //初始化地图中心点
      })
      // 后续传递map数据 - vuex无法存储
      callback(map)
      // 在图面添加工具条控件, 工具条控件只有缩放功能
      window.AMap.plugin(['AMap.ToolBar'], function () {
        map.addControl(new window.AMap.ToolBar())
      })

      if (!state.aMapObj.center) {
        // 获取初始中心点并更新中心坐标
        var currentCenter = map.getCenter()
        commit('setAMapObj', { center: [currentCenter.lng, currentCenter.lat], gps: false })
      }
      // 根据地图中心进行poi搜索
      dispatch('centerSearch')

      var moveendFn = e => {
        var currentCenter = map.getCenter()
        commit('setAMapObj', { center: [currentCenter.lng, currentCenter.lat], gps: true })
        dispatch('centerSearch')
      }
      map.on('moveend', moveendFn)
    },
    // 重置地图定位
    setMapCenter({ state }, { map, pos }) {
      if (!pos) {
        map.setCenter(new window.AMap.LngLat(state.aMapObj.location[0], state.aMapObj.location[1]))
      } else {
        map.setCenter(new window.AMap.LngLat(pos[0], pos[1]))
      }
    },
    // 根据中心点周边poi检索
    centerSearch({ state, commit }) {
      window.AMap.plugin('AMap.PlaceSearch', () => {
        //异步加载插件]
        if (!state.placeSearchObj) {
          var placeSearch = new window.AMap.PlaceSearch({
            // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
            pageSize: 20, // 单页显示结果条数
            pageIndex: 1 // 页码
          })
          commit('setPlaceSearch', placeSearch)
        }
        state.placeSearchObj.searchNearBy('', state.aMapObj.center, 200, function (status, result) {
          if (status == 'error') {
            window.VMonitor && window.VMonitor.report({
              ruleId: 'WLYhXxTj',
              api: 'searchNearBy',
              status: result
            });
          }
          commit('setPlaceSearchResult', result?.poiList?.pois || [])
          commit('setLoadFlag', false)
        })
      })
    },
    // 根据关键词poi检索
    keySearch({ state, commit }, keywords) {
      window.AMap.plugin('AMap.PlaceSearch', () => {
        //异步加载插件]
        if (!state.placeSearchObj) {
          var placeSearch = new window.AMap.PlaceSearch({
            // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
            pageSize: 20, // 单页显示结果条数
            pageIndex: 1 // 页码
          })
          commit('setPlaceSearch', placeSearch)
        }
        state.placeSearchObj.search(keywords, function (status, result) {
          if (status == 'error') {
            window.VMonitor && window.VMonitor.report({
              ruleId: 'WLYhXxTj',
              api: 'searchKey',
              status: result
            });
          }
          commit('setKeySearchResult', result?.poiList?.pois || [])
        })
      })
    }
  },
  mutations: {
    setAMapObj(state, obj) {
      if (obj.isGps && obj.center) {
        obj.center = wgs84togcj02(obj.center[0], obj.center[1])
        obj['location'] = obj.center
        obj['gps'] = true
      }
      state.aMapObj = Object.assign({}, state.aMapObj, obj)
    },
    setPlaceSearch(state, obj) {
      state.placeSearchObj = obj
    },
    setPlaceSearchResult(state, obj) {
      state.placeSearchResult = obj
    },
    setKeySearchResult(state, obj) {
      state.keySearchResult = obj
    },
    clearMapResult(state) {
      state.placeSearchResult = []
      state.keySearchResult = []
      state.aMapObj.center = null
      state.aMapObj.gps = true
      state.loadingFlag = true
    },
    setLoadFlag(state, flag) {
      state.loadingFlag = flag
    }
  }
}
